<dx-data-grid
  [dataSource]="context.inventory_items"
  [remoteOperations]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [columnAutoWidth]="true"
  columnResizingMode="widget"
  (onSelectionChanged)="onselect($event)"
  (onRowRemoving)="removeInventory($event)"
  ><dxo-toolbar>
    <dxi-item name="searchPanel"></dxi-item>
  </dxo-toolbar>
  <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
  <dxo-search-panel
    [visible]="true"
    [placeholder]="'common.search' | translate"
  ></dxo-search-panel>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-selection
    [mode]="selectionMode"
    selectAllMode="allPages"
    showCheckBoxesMode="always"
  ></dxo-selection>
  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 75, 100]"
  ></dxo-pager>
  <dxo-editing
    mode="row"
    [allowUpdating]="false"
    [allowAdding]="false"
    [allowDeleting]="removingActivated"
    [useIcons]="true"
  ></dxo-editing>

  <dxi-column
    dataField="item_number"
    [caption]="'inventory.itemNumber' | translate"
    [allowHeaderFiltering]="false"
    [showInColumnChooser]="false"
  ></dxi-column>
  <dxi-column
    dataField="title"
    [caption]="'inventory.title' | translate"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="project_location_id"
    [caption]="'inventory.projectLocation' | translate"
  >
    <dxo-lookup
      displayExpr="name"
      valueExpr="id"
      [dataSource]="projectService.projectLocations$ | async"
    ></dxo-lookup
  ></dxi-column>
  <dxi-column
    dataField="building"
    [caption]="'inventory.building' | translate"
  ></dxi-column>
  <dxi-column
    dataField="room"
    [caption]="'inventory.room' | translate"
  ></dxi-column>
  <dxi-column
    dataField="storage_location"
    [caption]="'inventory.storageLocation' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="brand"
    [caption]="'inventory.brand' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="serial_number"
    [caption]="'inventory.serialNumber' | translate"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="quantity"
    [caption]="'inventory.quantity' | translate"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="unit_of_quantity"
    [caption]="'inventory.unitOfQuantity' | translate"
    ><dxo-lookup
      [dataSource]="inventoryService.units$ | async"
      displayExpr="label"
      valueExpr="key"
    ></dxo-lookup
  ></dxi-column>
  <dxi-column
    dataField="tangible_asset_type"
    [caption]="'inventory.tangibleAssetType' | translate"
    ><dxo-lookup
      [dataSource]="inventoryService.tangibleAssetTypes$ | async"
      displayExpr="label"
      valueExpr="key"
    ></dxo-lookup
  ></dxi-column>
  <dxi-column
    dataField="type"
    [caption]="'inventory.type' | translate"
  ></dxi-column>
  <dxi-column
    dataField="goods_type"
    [caption]="'inventory.goodsType' | translate"
    ><dxo-lookup
      [dataSource]="inventoryService.goodsTypes$ | async"
      displayExpr="label"
      valueExpr="key"
    ></dxo-lookup
  ></dxi-column>
  <dxi-column
    dataField="condition"
    [caption]="'inventory.condition' | translate"
  >
    <dxo-lookup
      [dataSource]="inventoryService.conditions$ | async"
      displayExpr="label"
      valueExpr="key"
    ></dxo-lookup>
  </dxi-column>
  <dxi-column
    dataField="color"
    [caption]="'inventory.color' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="dimension_length"
    [caption]="'inventory.dimensionLength' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="dimension_width"
    [caption]="'inventory.dimensionWidth' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="dimension_height"
    [caption]="'inventory.dimensionHeight' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="dimension_depth"
    [caption]="'inventory.dimensionDepth' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="dimension_diameter"
    [caption]="'inventory.dimensionDiameter' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="weight"
    [caption]="'inventory.weight' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="liquidation_value"
    [caption]="'inventory.liquidationValue' | translate"
    format="currency"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="continuation_value"
    [caption]="'inventory.continuationValue' | translate"
    format="currency"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="disposal_costs"
    [caption]="'inventory.disposalCosts' | translate"
    format="currency"
    [allowHeaderFiltering]="false"
  ></dxi-column>
  <dxi-column
    dataField="work_zone"
    [caption]="'inventory.workZone' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="operating_hours"
    [caption]="'inventory.operatingHours' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="construction_year"
    [caption]="'inventory.constructionYear' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column dataField="drive" [caption]="'inventory.drive' | translate">
    <dxo-lookup
      [dataSource]="inventoryService.drives$ | async"
      displayExpr="label"
      valueExpr="key"
    ></dxo-lookup>
  </dxi-column>
  <dxi-column
    dataField="general_inspection"
    [caption]="'inventory.generalInspection' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="first_registration_day"
    [caption]="'inventory.firstRegistrationDay' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="first_registration_month"
    [caption]="'inventory.firstRegistrationMonth' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="first_registration_year"
    [caption]="'inventory.firstRegistrationYear' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="mileage"
    [caption]="'inventory.mileage' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="vin"
    [caption]="'inventory.vin' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="license_plate"
    [caption]="'inventory.licensePlate' | translate"
    [allowHeaderFiltering]="false"
    [visible]="false"
  ></dxi-column>
  <dxi-column
    dataField="marked_for_check"
    [caption]="'inventory.markedForCheck' | translate"
    [visible]="false"
  ></dxi-column>
  <dxi-column type="buttons" [showInColumnChooser]="false">
    <dxi-button name="delete"></dxi-button>
    <dxi-button icon="to" [onClick]="edit"></dxi-button>
  </dxi-column>
</dx-data-grid>
